import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Card,
  CardBody,
  CardImg,
  Button,
  CustomInput,
  Input,
  Label,
  Nav,
  TabContent,
  TabPane,
  NavItem,
} from 'reactstrap';
import Languages from '../../../../../../data/languages';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Select from 'react-select';
import { reactSelectOptionDiffrentPro } from '../../../../../../helpers/Utils';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import Switch from 'rc-switch';
import { gAPI_Property_List_By_Group } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import LanguageTabs from '../../../propinfo/components/LanguageTabs/LanguageTabs';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'rc-switch/assets/index.css';
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ]
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];


const normalizeLocale = (l) => (l === "zh-TW" ? "hk" : l);

const pickLocale = (arr, lang) =>
  Array.isArray(arr) ? arr.find((x) => x.locale === lang) || null : null;

const emptyDraft = (lang) => ({
  assistant: {
    name: "",
    title: "",
    subTitle: "",
    locale: lang,
    suggestionBotSetting: {
      message: [{ statement: "How can I help?", locale: lang }],
      buttons: [{
        text: '',
        subTitle: '',
        value: '',
        actionType: 'SendToChatBot',
        locale: lang,
      }],
      placeHolderText: [{ statement: "Ask me anything about the hotel...", locale: lang }],
    }
  },
  chatbot: { title: "", subTitle: "", locale: lang },
  propertyChatbot: { title: "", subTitle: "", locale: lang },
  property: { title: "", subTitle: "", contactInformation: "", locale: lang }
});

const hasValue = (v) => typeof v === "string" && v.trim().length > 0;

const isAssistantFilled = (d) =>
  hasValue(d.name) || hasValue(d.title) || hasValue(d.subTitle) ||
  (d.suggestionBotSetting && d.suggestionBotSetting.buttons && d.suggestionBotSetting.buttons.length > 0) ||
  (d.suggestionBotSetting && hasValue(d.suggestionBotSetting.message));

const isChatbotFilled = (d) =>
  hasValue(d.title) || hasValue(d.subTitle);

const isPropertyFilled = (d) =>
  hasValue(d.title) || hasValue(d.subTitle) || hasValue(d.contactInformation);
export default function MultliLanguages({
  botSettings,
  saveIntegration,
  isHelpcenter,
  locale,
  menuItems = [],
  conversationFlowList = []
}) {
  console.log('setti', botSettings, locale)

  const [edit, setEdit] = useState(false);
  const [settings, setSettings] = useState(() => botSettings);

  // Suggestion Bot data comes from draft.assistant.suggestionBotSetting
  const [botLanguages, setBotLanguages] = useState([]);
  const [botLanguagesList, setBotLanguagesListt] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState({
    value: 'en',
    label: 'English',
  });
  const [property, setProperty] = useState([]);
  const [defaultUrls, setDefaultUrls] = useState([
    { url: '', languageCode: '' },
  ]);
  const [multiLangProperty, setMultiLangProperty] = useState(
    botSettings?.multiLanguageProperty || []
  );

  const [isAutoDetectLanguage, setIsAutoDetectLanguage] = useState(
    botSettings.features !== null &&
      botSettings.features.autoLanguageDetection !== undefined
      ? botSettings.features.autoLanguageDetection
      : false
  );
  const [isDefaultLanguageUrl, setIsDefaultLanguageUrl] = useState(
    botSettings.features !== null &&
      botSettings.features.defaultLanguageUrl !== undefined
      ? botSettings.features.defaultLanguageUrl
      : false
  );
  const [activeTab, setActiveTab] = useState("chatbot");
  const [selectedLang, setSelectedLang] = useState(locale);
  const [draft, setDraft] = useState(() =>
    emptyDraft(normalizeLocale(locale))
  );

  /* sync incoming settings */
  useEffect(() => {
    if (botSettings) {
      setSettings(botSettings);
    }
  }, [botSettings]);

  /* load draft on language/settings change */
  useEffect(() => {
    if (!settings || !selectedLang) return;
    setDraft(loadLocaleDraft(settings, selectedLang));
  }, [settings, selectedLang]);


  const handleAddMultiLang = () => {
    let lst = [...multiLangProperty];
    lst.push({ propertyId: '', languages: [] });
    setMultiLangProperty(lst);
  };

  const handleDropDownChange = (index, value) => {
    let lst = [...multiLangProperty];
    lst[index].propertyId = value;
    setMultiLangProperty(lst);
  };
  const handleAddLanguages = (index, selectedTags) => {
    let lst = [...multiLangProperty];
    lst[index].languages = selectedTags;
    setMultiLangProperty(lst);
  };

  const handleRemoveMultiLang = (val) => {
    let lst = [...multiLangProperty];
    lst = lst.filter((f, index) => index !== val);
    setMultiLangProperty(lst);
  };
  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements !== null && statements.length > 0) {
      const index = statements.findIndex((m) => m.locale === selectedLang);
      if (index === -1) {
        const englishIndex = statements.findIndex((m) => m.locale === 'en');
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };

  const handleSuggestionTextChange = (e) => {
    setDraft(prev => {
      if (prev.assistant.suggestionBotSetting.message !== undefined &&
        prev.assistant.suggestionBotSetting.message !== null &&
        prev.assistant.suggestionBotSetting.message.length > 0) {
        const index = prev.assistant.suggestionBotSetting.message.findIndex((m) => m.locale === selectedLang);
        let messages = [...prev.assistant.suggestionBotSetting.message];
        if (index === -1) {
          const newStatement = {
            statement: e.target.value,
            locale: selectedLang,
          };
          messages = [...prev.assistant.suggestionBotSetting.message, newStatement];
        } else {
          messages[index].statement = e.target.value;
        }
        return {
          ...prev,
          assistant: {
            ...prev.assistant,
            suggestionBotSetting: {
              ...prev.assistant.suggestionBotSetting,
              message: messages
            }
          }
        };
      }
      return prev;
    });
  };

  const handleSuggestionPlaceholderTextChange = (e) => {
    setDraft(prev => {
      if (prev.assistant.suggestionBotSetting.placeHolderText !== undefined &&
        prev.assistant.suggestionBotSetting.placeHolderText !== null &&
        prev.assistant.suggestionBotSetting.placeHolderText.length > 0) {
        const index = prev.assistant.suggestionBotSetting.placeHolderText.findIndex((m) => m.locale === selectedLang);
        let placeholders = [...prev.assistant.suggestionBotSetting.placeHolderText];
        if (index === -1) {
          const newStatement = {
            statement: e.target.value,
            locale: selectedLang,
          };
          placeholders = [...prev.assistant.suggestionBotSetting.placeHolderText, newStatement];
        } else {
          placeholders[index].statement = e.target.value;
        }
        return {
          ...prev,
          assistant: {
            ...prev.assistant,
            suggestionBotSetting: {
              ...prev.assistant.suggestionBotSetting,
              placeHolderText: placeholders
            }
          }
        };
      }
      return prev;
    });
  };

  const handleAddFields = () => {
    const newButton = {
      text: '',
      subTitle: '',
      value: '',
      actionType: 'SendToChatBot',
      locale: selectedLang
    };
    setDraft(prev => {
      const suggestionsBot = prev.assistant?.suggestionBotSetting || {
        message: [],
        placeHolderText: [],
        buttons: []
      };
      return {
        ...prev,
        assistant: {
          ...prev.assistant,
          suggestionBotSetting: {
            ...suggestionsBot,
            buttons: [...(suggestionsBot.buttons || []), newButton]
          }
        }
      };
    });
  };

  const handleRemoveFields = (index) => {
    setDraft(prev => {
      const suggestionsBot = prev.assistant?.suggestionBotSetting;
      if (!suggestionsBot || !suggestionsBot.buttons) return prev;
      return {
        ...prev,
        assistant: {
          ...prev.assistant,
          suggestionBotSetting: {
            ...suggestionsBot,
            buttons: suggestionsBot.buttons.filter((_, i) => i !== index)
          }
        }
      };
    });
  };

  const handleInputChange = (index, event) => {
    const { name: inputName, value: inputValue } = event.target;
    console.log('Button Updating...');
    setDraft((prev) => {
      const suggestionsBot = prev.assistant?.suggestionBotSetting;
      if (!suggestionsBot || !suggestionsBot.buttons || !suggestionsBot.buttons[index]) return prev;

      const updatedButtons = suggestionsBot.buttons.map((b, i) => {
        if (i !== index) return b;
        // set the changed field; if actionType changes, clear the `value` payload
        const base = { ...b, [inputName]: inputValue };
        if (inputName === 'actionType') {
          return { ...base, value: '' };
        }
        return base;
      });
      console.log('Updated Buttons:', updatedButtons);
      return {
        ...prev,
        assistant: {
          ...prev.assistant,
          suggestionBotSetting: {
            ...suggestionsBot,
            buttons: updatedButtons,
          },
        },
      };
    });
  };

  const handleActionValueChange = (index, value) => {
    setDraft(prev => {
      const suggestionsBot = prev.assistant?.suggestionBotSetting;
      if (!suggestionsBot || !suggestionsBot.buttons || !suggestionsBot.buttons[index]) return prev;

      const updatedButtons = [...suggestionsBot.buttons];
      updatedButtons[index] = {
        ...updatedButtons[index],
        value: value
      };
      console.log(" Updated Buttons:", updatedButtons);

      return {
        ...prev,
        assistant: {
          ...prev.assistant,
          suggestionBotSetting: {
            ...suggestionsBot,
            buttons: updatedButtons
          }
        }
      };
    });
  };

  const renderActionValueField = (nudge, index) => {
    // Default: keep existing behavior for unclear requirement(s)
    if (nudge.actionType === 'OPEN_URL') {
      return (
        <Colxx sm={5} className="mb-3">
          <Label>Open URL</Label>
          <Input
            type="text"
            name="value"
            value={nudge.value}
            onChange={(e) => handleActionValueChange(index, e.target.value)}
            placeholder="URL"
          />
        </Colxx>
      );
    }
    if (nudge.actionType === 'OPEN_WIDGET_MENU') {
      return (
        <Colxx sm={5} className="mb-3">
          <Label>Menu Item</Label>
          <Input
            type="select"
            name="value"
            value={nudge.value || ''}
            onChange={(e) => handleActionValueChange(index, e.target.value)}
            disabled
          >
            <option value="">Select</option>
            {menuItems.map((m) => (
              <option key={m.id} value={m.id}>
                {m.title}
              </option>
            ))}
          </Input>
        </Colxx>
      );
    }
    if (nudge.actionType === 'STATIC_FLOW') {
      return (
        <Colxx sm={5} className="mb-3">
          <Label>Conversation Flow</Label>
          <Input
            type="select"
            name="value"
            value={nudge.value || ''}
            onChange={(e) => handleActionValueChange(index, e.target.value)}
            disabled
          >
            <option value="">Select</option>
            {conversationFlowList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </Input>
        </Colxx>
      );
    }
    return null;

  };
  /* ==================== End Suggestion Bot Handlers ==================== */

  const toggleMenu = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    const getLanguage = Languages.filter(
      (item) => item.code === botSettings.defaultLanguage
    );
    if (
      botSettings?.multiLanguageProperty &&
      botSettings?.multiLanguageProperty.length > 0
    ) {
      let lst = [];
      botSettings.multiLanguageProperty.map((l) => {
        let options = [];
        Languages.filter(
          (f) => l.languages.filter((i) => i === f.code).length > 0
        ).map((o) =>
          options.push({ value: o.code, label: o.name, key: o.code })
        );
        lst.push({
          propertyId: l.propertyId,
          languages: options,
        });
      });
      setMultiLangProperty(lst);
    }

    const filtered = Languages.filter((el) => {
      return botSettings.languages.indexOf(el.code) !== -1;
    });
    setBotLanguages(filtered);

    const languageList = Languages.map((elem) => {
      elem.checked = false;
      filtered.forEach((lang) => {
        if (lang.code === elem.code) {
          elem.checked = true;
        }
      });
      return elem;
    });

    setBotLanguagesListt(languageList);

    if (getLanguage !== undefined) {
      let lan = { value: getLanguage[0].code, label: getLanguage[0].name };
      setSelectedLanguage(lan);
    }

    if (
      botSettings.features !== undefined &&
      botSettings.features !== null &&
      botSettings.features.languageUrl !== undefined &&
      botSettings.features.languageUrl !== null &&
      botSettings.features.languageUrl.length > 0
    ) {
      let links = [];
      botSettings.features.languageUrl.map((m) =>
        links.push({
          url: m.url,
          languageCode: m.languageCode,
        })
      );
      setDefaultUrls(links);
    }
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setProperty([...res.data]);
      })
      .catch((err) => console.error(err));
  }, [botSettings, locale]);


  const handleChange = (e) => {
    const value = e.target.checked;
    setSettings({
      ...settings,
      [e.target.name]: value,
    });
  };

  const handleSave = () => {
    setEdit(!edit);
    const newSettings = {
      ...settings,
      features: {
        ...(settings.features || {}),
        languageUrl: defaultUrls.length > 0 ? defaultUrls : settings.features?.languageUrl,
      },
      multiLanguageProperty: multiLangProperty.map((m) => ({
        propertyId: m.propertyId,
        languages: m.languages.map((l) => l.value),
      })),
    };
    setSettings(newSettings);
    // update local draft to reflect saved settings for current lang
    setDraft(loadLocaleDraft(newSettings, selectedLang));
    saveIntegration({ botSetting: newSettings });
  };


  const handleChangeSelect = (selectedOptions) => {
    setSelectedLanguage(selectedOptions);
    setSettings({ ...settings, defaultLanguage: selectedOptions.value });
  };
  const handleLanguageChange = (e) => {
    const values = botLanguagesList.map((elem) => {
      if (elem.code === e.target.value) {
        elem.checked = !elem.checked;
      }
      return {
        ...elem,
      };
    });
    setBotLanguagesListt(values);
  };

  useEffect(() => {
    const langArr = botLanguagesList
      .filter((elem) => elem.checked === true)
      .map((elem) => elem.code);

    //console.log(langArr);

    setSettings({
      ...settings,
      languages: langArr,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [botLanguagesList]);

  const handleChangeURL = (e, index) => {
    const values = [...defaultUrls];
    if (e.target.name === 'url') {
      values[index].url = e.target.value;
    }
    setDefaultUrls(values);
  };
  const handleChangeLanguageCode = (lang, index) => {
    const values = [...defaultUrls];
    values[index].languageCode = lang.value;
    setDefaultUrls(values);
  };
  const AddURL = () => {
    let links = [...defaultUrls];
    links.push({
      url: '',
      languageCode: '',
    });
    setDefaultUrls(links);
  };

  const RemoveURL = (index) => {
    const values = [...defaultUrls];
    values.splice(index, 1);
    setDefaultUrls(values);
  };

  const handleAutoLanguageDetection = (e) => {
    setIsAutoDetectLanguage(e);
    const newSettings = {
      ...settings,
      features: {
        ...(settings.features || {}),
        autoLanguageDetection: e,
      },
    };
    setSettings(newSettings);
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Auto language detection enabled successfully'
          : 'Auto language detection disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: newSettings });
  };

  const handleDefaultLanguageUrl = (e) => {
    setIsDefaultLanguageUrl(e);
    const newSettings = {
      ...settings,
      features: {
        ...(settings.features || {}),
        defaultLanguageUrl: e,
      },
    };
    setSettings(newSettings);
    setTimeout(() => {
      NotificationManager.success(
        '',
        e === true
          ? 'Default language url enabled successfully'
          : 'Default language url disabled successfully',
        3000,
        null,
        null,
        'success'
      );
    }, 100);
    saveIntegration({ botSetting: newSettings });
  };

  const loadLocaleDraft = (settings, lang) => {
    const l = normalizeLocale(lang);

    const assistant = pickLocale(settings.assistantDetails, l);
    const chatbot = pickLocale(settings.chatBot?.chatBotDetails, l);
    const pcb = pickLocale(
      settings.chatBot?.propertyChatBot?.propertyDetails,
      l
    );
    const prop = pickLocale(settings.chatBot?.propertyDetails, l);


    const rootSuggestion = settings.suggestionBotSetting || {};
    const allMessages = Array.isArray(rootSuggestion.message) ? rootSuggestion.message : [];
    const allPlaceholders = Array.isArray(rootSuggestion.placeHolderText) ? rootSuggestion.placeHolderText : [];
    const allButtons = Array.isArray(rootSuggestion.buttons) ? rootSuggestion.buttons : [];
    const messagesForLang = allMessages.filter(
      (m) => normalizeLocale(m.locale) === l
    );

    const placeholdersForLang = allPlaceholders.filter(
      (m) => normalizeLocale(m.locale) === l
    );

    const buttonsForLang = allButtons.filter(
      (b) => b && normalizeLocale(b.locale) === l
    );

    const fallbackMessages =
      messagesForLang.length > 0
        ? messagesForLang
        : allMessages.filter((m) => normalizeLocale(m.locale) === 'en');

    const fallbackPlaceholders =
      placeholdersForLang.length > 0
        ? placeholdersForLang
        : allPlaceholders.filter((m) => normalizeLocale(m.locale) === 'en');

    const fallbackButtons =
      buttonsForLang.length > 0
        ? buttonsForLang
        : allButtons.filter((b) => b && normalizeLocale(b.locale) === 'en');


    const suggestionBotSetting = {
      ...emptyDraft(l).assistant.suggestionBotSetting,

      message: fallbackMessages.length
        ? fallbackMessages.map(m => ({
          ...m,
          locale: l,
        }))
        : emptyDraft(l).assistant.suggestionBotSetting.message,

      placeHolderText: fallbackPlaceholders.length
        ? fallbackPlaceholders.map(m => ({
          ...m,
          locale: l,
        }))
        : emptyDraft(l).assistant.suggestionBotSetting.placeHolderText,

      buttons: fallbackButtons.length
        ? fallbackButtons.map(b => ({
          ...b,
          locale: l,
        }))
        : [],
    };
    return {
      assistant: {
        ...emptyDraft(l).assistant,
        ...(assistant || {}),
        suggestionBotSetting,
      },
      chatbot: chatbot ? { ...chatbot } : emptyDraft(l).chatbot,
      propertyChatbot: pcb ? { ...pcb } : emptyDraft(l).propertyChatbot,
      property: prop ? { ...prop } : emptyDraft(l).property
    };
  };


  const persistDraft = (settings, draft, lang) => {
    const l = normalizeLocale(lang);
    const existingRoot = settings.suggestionBotSetting || {};

    const allMessages = Array.isArray(existingRoot.message)
      ? existingRoot.message
      : [];

    const allPlaceholders = Array.isArray(existingRoot.placeHolderText)
      ? existingRoot.placeHolderText
      : [];

    const allButtons = Array.isArray(existingRoot.buttons)
      ? existingRoot.buttons
      : [];

    const otherLocaleMessages =
      allMessages.filter(m => normalizeLocale(m.locale) !== l);

    const otherLocalePlaceholders =
      allPlaceholders.filter(m => normalizeLocale(m.locale) !== l);

    const otherLocaleButtons =
      allButtons.filter(b => normalizeLocale(b.locale) !== l);

    const draftMessages =
      draft.assistant?.suggestionBotSetting?.message?.filter(
        m => normalizeLocale(m.locale) === l
      ) || [];

    const draftPlaceholders =
      draft.assistant?.suggestionBotSetting?.placeHolderText?.filter(
        m => normalizeLocale(m.locale) === l
      ) || [];

    const draftButtons =
      draft.assistant?.suggestionBotSetting?.buttons?.filter(
        b => normalizeLocale(b.locale) === l
      ) || [];

    const hasRealChanges =
      draftMessages.some(m => m.statement?.trim() !== "") ||
      draftPlaceholders.some(m => m.statement?.trim() !== "") ||
      draftButtons.some(b =>
        b.text?.trim() !== "" ||
        b.subTitle?.trim() !== "" ||
        b.value?.trim() !== ""
      );

    const suggestionBotSetting = hasRealChanges
      ? {
        ...existingRoot,
        message: [...otherLocaleMessages, ...draftMessages],
        placeHolderText: [...otherLocalePlaceholders, ...draftPlaceholders],
        buttons: [...otherLocaleButtons, ...draftButtons],
      }
      : existingRoot;
    return {
      ...settings,
      suggestionBotSetting,

      assistantDetails: [
        ...settings.assistantDetails.filter(d => d.locale !== l),
        ...(isAssistantFilled(draft.assistant)
          ? [{ ...draft.assistant, locale: l }]
          : [])
      ],

      chatBot: {
        ...settings.chatBot,

        chatBotDetails: [
          ...settings.chatBot.chatBotDetails.filter(d => d.locale !== l),
          ...(isChatbotFilled(draft.chatbot)
            ? [{ ...draft.chatbot, locale: l }]
            : [])
        ],

        propertyChatBot: {
          ...settings.chatBot.propertyChatBot,
          propertyDetails: [
            ...settings.chatBot.propertyChatBot.propertyDetails.filter(
              d => d.locale !== l
            ),
            ...(isChatbotFilled(draft.propertyChatbot)
              ? [{ ...draft.propertyChatbot, locale: l }]
              : [])
          ]
        },

        propertyDetails: [
          ...settings.chatBot.propertyDetails.filter(d => d.locale !== l),
          ...(isPropertyFilled(draft.property)
            ? [{ ...draft.property, locale: l }]
            : [])
        ]
      }
    };
  };

  const updateDraft = (section, name, value) => {
    setDraft(prev => ({
      ...prev,
      [section]: { ...prev[section], [name]: value }
    }));
  };

  /* switch language safely */
  const SwitchLanguage = (lang) => {
    setSelectedLang(lang);
  };

  /* save */
  const handleSubmit = () => {
    const updated = persistDraft(settings, draft, selectedLang);
    setSettings(updated);
    setDraft(loadLocaleDraft(updated, selectedLang));
    saveIntegration({ botSetting: updated });
  };

  const Show = () => {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody>
            <div className="text-center">
              <h6>Languages:</h6>
              <Separator className="mb-3" />
              {/* <div className="mb-1">
                <b>Enable:</b>
                {botSettings.multilingual ? ' Yes' : ' No'}
              </div> */}
              <div className="mb-1">
                <b>Default Language:</b> {selectedLanguage.label}
              </div>
              <div className="mb-1 mt-2">
                <b>Enable Multi Language:</b>
                {botSettings.multilingual ? ' Yes' : ' No'}
              </div>
              {/* <div className="mb-1">
                <b>Selected Property Languages:</b>
                <Row>
                  {botLanguages.map((lang, msgIndex) => {
                    return (
                      <Colxx xxs="4" key={msgIndex}>
                        {' '}
                        <p className="text-left">{lang.name}</p>
                      </Colxx>
                    );
                  })}
                </Row>
              </div> */}

              {isHelpcenter && (
                <Fragment>
                  <div className="d-flex justify-content-xl-around">
                    <div className="mb-1 mt-2">
                      <b>Auto Language Detection:</b>
                      {botSettings.features.autoLanguageDetection
                        ? ' Yes'
                        : ' No'}
                    </div>
                    <div className="mb-1 mt-2">
                      <b>Default Language URL:</b>
                      {botSettings.features.defaultLanguageUrl ? ' Yes' : ' No'}
                    </div>
                  </div>
                  <div className="mb-1">
                    <b>Languages URLs:</b>
                    {defaultUrls.length > 0 &&
                      defaultUrls.filter((k) => k.url !== '').length !== 0 ? (
                      <Fragment>
                        <Row>
                          <Colxx xxs="8">
                            <b>URLs</b>
                          </Colxx>
                          <Colxx xxs="4">
                            <b>Language Code</b>
                          </Colxx>
                        </Row>
                        {defaultUrls.map((lang, i) => {
                          return (
                            <Row className="mt-2" key={i}>
                              <Colxx xxs="8">
                                {' '}
                                <p className="text-left">
                                  <a
                                    href={`${lang.url}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    {lang.url}
                                  </a>
                                </p>
                              </Colxx>
                              <Colxx xxs="4">
                                <p>{lang.languageCode}</p>
                              </Colxx>
                            </Row>
                          );
                        })}
                      </Fragment>
                    ) : (
                      <p className="text-center mt-2">No Urls Available</p>
                    )}
                  </div>
                </Fragment>
              )}
              <Button
                size="xs"
                color="success"
                outline
                style={{ marginTop: '20px' }}
                onClick={() => {
                  setEdit(!edit);
                }}
              >
                Edit
              </Button>
            </div>
          </CardBody>
        ) : null}
      </Fragment>
    );
  };

  function Edit() {
    return (
      <Fragment>
        {botSettings ? (
          <CardBody>
            <div className="text-center">
              <h6>Language</h6>
              <Separator className="mb-3" />
              {/* <div className="mb-1">
                <b>Choose Languages</b>
                <br />
                <Row>
                  {botLanguagesList.map((elem, index) => (
                    <Colxx xxs="4" key={index}>
                      {' '}
                      <CustomInput
                        key={index}
                        type="checkbox"
                        value={elem.code}
                        id={elem.code}
                        onChange={handleLanguageChange}
                        checked={elem.checked}
                        className="text-left"
                      >
                        {elem.name}
                      </CustomInput>
                    </Colxx>
                  ))}
                </Row>
              </div> */}

              <div className="mb-3 text-left">
                <b>Default Language</b>
                <br />
                <Select
                  isMulti={false}
                  className="react-select"
                  classNamePrefix="react-select"
                  name="defaultLanguage"
                  value={selectedLanguage}
                  placeholder="Select Default Language"
                  onChange={handleChangeSelect}
                  options={
                    Languages
                      ? reactSelectOptionDiffrentPro(
                        botLanguages,
                        true,
                        'code',
                        'name',
                        ''
                      )
                      : []
                  }
                />
              </div>
              <div className="mb-1 d-flex text-left">
                <b>Enable Multi Language</b>
                <CustomInput className='ml-2'
                  id="lan"
                  type="checkbox"
                  checked={settings.multilingual}
                  name="multilingual"
                  onChange={handleChange}
                />
              </div>
              <div className="mb-3">
                {multiLangProperty.length > 0 &&
                  multiLangProperty.map((m, index) => (
                    <Row className="mb-2 text-left">
                      <Colxx sm={5}>
                        <Label>Property</Label>
                        <Input className='input_sty'
                          type="select"
                          value={m.propertyId}
                          name="type"
                          onChange={(e) =>
                            handleDropDownChange(index, e.target.value)
                          }
                        >
                          <option value="">Select All</option>
                          <option value="-1">All Properties</option>
                          {property.map((p) => (
                            <option value={p.id}>{p.name}</option>
                          ))}
                        </Input>
                      </Colxx>
                      <Colxx sm={5}>
                        <Label>Languages</Label>
                        <Select
                          components={{ Input: CustomSelectInput }}
                          className="react-select"
                          isMulti={true}
                          classNamePrefix="react-select"
                          name="form-field-name"
                          options={Languages.map((x, i) => {
                            return { label: x.name, value: x.code, key: i };
                          })}
                          value={m.languages}
                          onChange={(val) => handleAddLanguages(index, val)}
                        />
                      </Colxx>
                      <Colxx sm={2} className="mt-3">
                        <Button
                          color="danger"
                          size="xs"
                          onClick={() => handleRemoveMultiLang(index)}
                        >
                          x
                        </Button>
                      </Colxx>
                    </Row>
                  ))}
              </div>
              <div className="mb-2">
                {' '}
                <Row className="text-left">
                  <Colxx sm={5}>
                    {' '}
                    <Button
                      color="danger"
                      size="xs"
                      onClick={() => handleAddMultiLang()}
                    >
                      + Add Property Language
                    </Button>
                  </Colxx>
                </Row>
              </div>
              <div className="row mt-3 ml-2 mb-1">
                <div className="d-flex w-100">
                  <h5 style={{ marginTop: '0.15rem' }}>
                    Auto language detection
                  </h5>
                  <Switch
                    className="agentswitch custom-switch-primary custom-switch-small ml-2"
                    checked={isAutoDetectLanguage}
                    name="enabled"
                    onChange={(e) => handleAutoLanguageDetection(e)}
                  />
                </div>
                <div
                  className="row text-left"
                  style={{ marginLeft: '0', marginRight: '1rem' }}
                >
                  {isAutoDetectLanguage === false ? (
                    <p className="m-1 pr-4">
                      When enabled, the language will be auto detected based on
                      the first two messages guest sends. Rest of the
                      conversation will be in that language.
                    </p>
                  ) : (
                    <ul className="pl-2 pr-5">
                      <li>
                        the AI Chatbot will attempt to detect the language based
                        on the customer message and respond in the same
                        language.
                      </li>
                      <li>
                        the first 5 customer messages are detected, and the
                        responses after that are set to the language of the 5th
                        message.
                      </li>
                      <li>
                        if the customer message is not in one of the enabled
                        languages, AI Chatbot will respond with “Sorry, I do not
                        support this language”. The message is sent in the same
                        language as the user message.
                      </li>
                    </ul>
                  )}
                </div>
              </div>
              {isHelpcenter === true && (
                <Fragment>
                  <div className="row mt-3 ml-2 mb-1">
                    <div className="d-flex w-100">
                      <h5 style={{ marginTop: '0.15rem' }}>
                        Default language by URL
                      </h5>
                      <Switch
                        className="agentswitch custom-switch-primary custom-switch-small ml-2"
                        checked={isDefaultLanguageUrl}
                        name="enabled"
                        onChange={(e) => handleDefaultLanguageUrl(e)}
                      />
                    </div>
                  </div>
                  {defaultUrls.length > 0 &&
                    defaultUrls.map((elem, index) => (
                      <Row className="mt-2" key={index}>
                        <Colxx md={'6'}>
                          <Input className='input_sty'
                            type="textarea"
                            value={elem.url}
                            onChange={(e) => handleChangeURL(e, index)}
                            name="url"
                            placeholder="URL"
                            style={{ height: '40px' }}
                          ></Input>
                        </Colxx>
                        <Colxx md={'4'}>
                          <Select
                            isMulti={false}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="languageCode"
                            value={Languages.filter(
                              (l) => l.code === elem.languageCode
                            ).map((x) => ({ label: x.name, value: x.code }))}
                            placeholder="Select Language"
                            onChange={(e) => handleChangeLanguageCode(e, index)}
                            options={
                              Languages
                                ? reactSelectOptionDiffrentPro(
                                  Languages,
                                  true,
                                  'code',
                                  'name',
                                  ''
                                )
                                : []
                            }
                          />
                        </Colxx>
                        <Colxx md={'2'}>
                          <Button
                            color="danger"
                            size="xs"
                            outline
                            onClick={() => RemoveURL(index)}
                          >
                            -
                          </Button>
                        </Colxx>
                      </Row>
                    ))}
                  <div className="row mt-3 ml-2 mb-1">
                    <Button color="success" size="xs" outline onClick={AddURL}>
                      +Add
                    </Button>
                  </div>
                </Fragment>
              )}
              <Separator className="my-2"></Separator>
              <div className="mb-2" style={{ marginTop: '20px' }}>
                <Button color="primary" size="xs" onClick={handleSave}>
                  Save
                </Button>
                <Button
                  size="xs"
                  color="secondary"
                  className='ml-2'
                  onClick={() => {
                    setEdit(!edit);
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </CardBody>
        ) : null}
      </Fragment>
    );
  }
  function widget() {
    return (
      <Fragment>
        <CardBody className='ml-2 mr-4'>
          <div className="text-left">
            <h6 className='mb-2'>Set up all language specific text for the web widget at one place</h6>
            <div className="mb-3 mt-4">
              <Row>
                <Colxx md={12} >
                  <LanguageTabs
                    integrationLanguages={multiLangProperty?.length ? Array.from(new Set(multiLangProperty.flatMap(p => p.languages.map(l => l.value)))) : [locale]}
                    selectedTab={selectedLang}
                    setLanguage={SwitchLanguage}
                  />
                </Colxx>
              </Row>

              <h6 className='mt-2'>Widget Components</h6>
              <div className='mt-4 mb-3'>
                <Label>Assistant Name</Label>
                <br />
                <Input className='input_sty' name="name"
                  value={draft.assistant.name}
                  onChange={e => updateDraft("assistant", "name", e.target.value)}
                />
              </div>
              <div className='mb-3'>
                <Label>Title</Label>
                <br />
                <Input className='input_sty'
                  name="title"
                  value={draft.assistant.title}
                  onChange={e => updateDraft("assistant", "title", e.target.value)}
                />
              </div>
              <div className='mb-3'>
                <Label>SubTitle</Label>
                <br />
                <Input className='input_sty'
                  name="subTitle"
                  value={draft.assistant.subTitle}
                  onChange={e => updateDraft("assistant", "subTitle", e.target.value)}
                />
              </div>

              <div className="mt-4">
                <h6 style={{ borderTop: '1px solid #ddd', paddingTop: '1rem', marginBottom: '1rem' }}>Suggestions</h6>

                {/* Messages */}
                <div className="mb-3">
                  <Label>Hero Message</Label>
                  <Input
                    type="textarea"
                    name="text"
                    value={getLocalStatement(draft.assistant.suggestionBotSetting?.message)}
                    onChange={event => handleSuggestionTextChange(event)}
                  />
                </div>

                {/* Typing Placeholder Text */}
                <div className="mb-3">
                  <Label>Typing Placeholder Text</Label>
                  <Input
                    type="text"
                    name="text"
                    value={getLocalStatement(draft.assistant.suggestionBotSetting?.placeHolderText)}
                    onChange={event => handleSuggestionPlaceholderTextChange(event)}
                  />
                </div>

                {/* Buttons */}
                <div className="mb-3">
                  <Label>Suggestion Buttons</Label>
                  <Separator className="mb-2" />
                  {draft.assistant.suggestionBotSetting?.buttons && draft.assistant.suggestionBotSetting.buttons.length > 0 ? (
                    draft.assistant.suggestionBotSetting.buttons.map((nudge, index) => (
                      <Fragment>
                        <Row key={index}>
                          <Colxx sm={6} className="mb-3">
                            <Label>Title</Label>
                            <Input
                              type="text"
                              name="subTitle"
                              placeholder="Title must be 10-20 characters"
                              value={nudge.subTitle}
                              onChange={event => handleInputChange(index, event)}
                            />
                          </Colxx>
                          <Colxx sm={5} className="mb-3">
                            <Label>Sub Title</Label>
                            <Input
                              type="text"
                              name="text"
                              placeholder="SubTitle must be 10-20 characters"
                              value={nudge.text}
                              onChange={event => handleInputChange(index, event)}
                            />
                          </Colxx>
                          <Colxx sm={6} className="mb-3">
                            <Label>Action Type</Label>
                            <Input
                              type="select"
                              name="actionType"
                              value={nudge.actionType || 'SendToChatBot'}
                              onChange={event => handleInputChange(index, event)}
                              disabled
                            >
                              <option value="SendToChatBot">Send to Chatbot</option>
                              <option value="OPEN_WIDGET_MENU">Open Web Widget Menu</option>
                              <option value="OPEN_URL">Open URL</option>
                              <option value="STATIC_FLOW">Trigger Static Conversation Flow</option>
                              <option value="PROPERTY_LIST">Show Property List</option>
                            </Input>
                          </Colxx>
                          {renderActionValueField(nudge, index)}
                          {(nudge.actionType === 'SendToChatBot') && (
                            <Colxx sm={5} className="mb-3">
                              <Label>Chatbot Message</Label>
                              <Input
                                type="text"
                                name="value"
                                value={nudge.value}
                                onChange={event => handleInputChange(index, event)}
                              />
                            </Colxx>
                          )}

                          <Colxx
                            sm={1}
                            className="mb-3"
                            style={{
                              marginTop: "-37px",
                              ...(nudge.actionType === "PROPERTY_LIST" && {
                                marginLeft: "22.8rem"
                              })
                            }}
                          >
                            <Label style={{ marginLeft: '-5px' }}>Remove</Label>
                            <div>
                              <Button
                                onClick={() => handleRemoveFields(index)}
                                color="secondary"
                                size="xs"
                                outline
                                style={{ margin: '4px' }}
                              >
                                -
                              </Button>
                            </div>
                          </Colxx>
                        </Row>
                        {index !== draft.assistant.suggestionBotSetting.buttons.length - 1 && (
                          <Separator className="my-3" />
                        )}
                      </Fragment>
                    ))
                  ) : (
                    <p className="text-center text-muted">No buttons added yet</p>
                  )}
                  <Button
                    onClick={handleAddFields}
                    color="primary"
                    size="xs"
                    outline
                    style={{ margin: '6px' }}
                  >
                    + Add Button
                  </Button>
                </div>
              </div>
              {/* ==================== End Suggestions Section ==================== */}
            </div>
            <Separator className="mb-3" />
            <div className='mb-2 text-center'>
              <Button color="primary" size="xs" onClick={handleSubmit}>
                Save
              </Button>
            </div>
          </div>
        </CardBody>
      </Fragment>
    )
  }

  return (
    <Fragment>
      <Card className="mb-4">{edit ? Edit() : Show()}</Card>
      <Card className="mb-4">{widget()}</Card>
      <Card className=' mb-4'>
        <CardBody className='ml-2 mr-4'>
          <div className="text-left">
            <div className='mb-4'>
              <h6>Chatbot Info</h6>

              <Nav tabs className="separator-tabs ml-0 mr-0 mt-4">
                <NavItem className="w-30 text-center">
                  <NavLink
                    style={{ marginRight: "0px" }}
                    to="#"
                    location={{}}
                    className={classnames({
                      active: activeTab === 'chatbot',
                      'nav-link': true,
                    })}
                    onClick={() => toggleMenu('chatbot')}
                  >
                    Group Chatbot
                  </NavLink>
                </NavItem>
                <NavItem className="w-30 text-center">
                  <NavLink
                    style={{ marginRight: "0px" }}
                    to="#"
                    location={{}}
                    className={classnames({
                      active: activeTab === 'propertybot',
                      'nav-link': true,
                    })}
                    onClick={() => setActiveTab('propertybot')}
                  >
                    Property Chatbot
                  </NavLink>
                </NavItem>
                <NavItem className="w-30 text-center">
                  <NavLink
                    style={{ marginRight: "0px" }}
                    to="#"
                    location={{}}
                    className={classnames({
                      active: activeTab === 'property',
                      'nav-link': true,
                    })}
                    onClick={() => setActiveTab('property')}
                  >
                    Property
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="chatbot">
                  <div className="pt-2 pr-4 pl-4 pb-2">
                    <Row>
                      <Colxx md={12} className="mt-2">
                        <Label>Title</Label>
                        <div className="mb-2">
                          <Input className='input_sty'
                            type="text"
                            name="title"
                            placeholder="Title"
                            value={draft.chatbot.title}
                            onChange={e => updateDraft("chatbot", "title", e.target.value)}
                          ></Input>
                        </div>
                      </Colxx>
                      <Colxx md={12} className="mt-2">
                        <Label>Sub Title</Label>
                        <div className="mb-2">
                          <Input className='input_sty'
                            type="text"
                            name="subTitle"
                            placeholder="Sub Title"
                            value={draft.chatbot.subTitle}
                            onChange={e => updateDraft("chatbot", "subTitle", e.target.value)}
                          ></Input>
                        </div>
                      </Colxx>
                    </Row>
                  </div>
                </TabPane>
              </TabContent>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="propertybot">
                  <div className="pt-2 pr-4 pl-4 pb-2">
                    <Row>
                      <Colxx md={12} className="mt-2">
                        <Label>Title</Label>
                        <div className="mb-2">
                          <Input className='input_sty'
                            type="text"
                            name="title"
                            placeholder="Title"
                            value={draft.propertyChatbot.title}
                            onChange={e => updateDraft("propertyChatbot", "title", e.target.value)}
                          />
                        </div>
                      </Colxx>

                      <Colxx md={12} className="mt-2">
                        <Label>Sub Title</Label>
                        <div className="mb-2">
                          <Input className='input_sty'
                            type="text"
                            name="subTitle"
                            placeholder="Sub Title"
                            value={draft.propertyChatbot.subTitle}
                            onChange={e => updateDraft("propertyChatbot", "subTitle", e.target.value)}
                          />
                        </div>
                      </Colxx>
                    </Row>
                  </div>
                </TabPane>
              </TabContent>

              <TabContent activeTab={activeTab} >
                <TabPane tabId="property">
                  <div className="pt-2 pr-4 pl-4 pb-2">
                    <Row>
                      <Colxx md={12} className="mt-2">
                        <Label>Title</Label>
                        <div className="mb-2">
                          <Input className='input_sty' name="title"
                            value={draft.property.title}
                            onChange={e => updateDraft("property", "title", e.target.value)} />
                        </div>
                      </Colxx>
                      <Colxx md={12} className="mt-2">
                        <Label>Sub Title</Label>
                        <div className="mb-2">
                          <Input className='input_sty' name="subTitle"
                            value={draft.property.subTitle}
                            onChange={e => updateDraft("property", "subTitle", e.target.value)} />

                        </div>
                      </Colxx>

                      <Colxx md={12} className="mt-2">
                        <Label>Welcome Message</Label>

                        <ReactQuill
                          theme="snow"
                          value={draft.property.contactInformation}
                          onChange={(content, delta, source) => {
                            if (source === "user") {
                              updateDraft("property", "contactInformation", content);
                            }
                          }}
                          modules={quillModules}
                          formats={quillFormats}
                        />
                      </Colxx>

                    </Row>
                  </div>
                </TabPane>
              </TabContent >

            </div >
            <Separator className="mb-3" />
            <div className='mb-2 text-center'>
              <Button color="primary" size="xs" onClick={handleSubmit}>
                Save
              </Button>
            </div>
          </div >
        </CardBody >
      </Card >
    </Fragment >
  )
}
